import { DEFAULT_PAGE_SIZE } from "@constants";
import { axiosRequest } from "../axios.config";

const reviewApi = {
  // Course review
  getCourseReviews: async ({
    courseId,
    pageNumber = 1,
    keyword,
    rating = 0,
  }) => {
    const url = "CourseReview/Get-All";
    const config = {
      params: {
        courseId,
        pageSize: DEFAULT_PAGE_SIZE,
        orderBy: "createdAt desc",
        pageNumber,
        keyword,
        rating,
      },
    };

    if (rating === 0) {
      delete config.params.rating;
    }

    const response = await axiosRequest.get(url, config);
    return response;
  },
  checkUserReview: async (courseId) => {
    const url = "CourseReview/check-user-course-review";
    const config = { params: { courseId } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  submitReviewCourse: async ({ enrollmentId, content, rating }) => {
    const url = "CourseReview";
    const data = {
      enrollmentId,
      content,
      rating,
    };
    const response = await axiosRequest.post(url, data);
    return response;
  },
  updateReviewCourse: async ({ reviewId, content, rating }) => {
    const url = `CourseReview?id=${reviewId}`;
    const data = {
      content,
      rating,
    };
    const response = await axiosRequest.put(url, data);
    return response;
  },
  getTotalReviewsCourse: async (courseId) => {
    const url = "CourseReview/Get-total-Review-of-course";
    const config = { params: { courseId } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  getAverageRatingCourse: async (courseId) => {
    const url = "CourseReview/Get-Avg-Rating";
    const config = { params: { courseId } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  getReviewSummaryCourse: async (courseId) => {
    const url = "CourseReview/Get-Rating";
    const config = { params: { courseId } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  // Get user review
  getAllReviewsUser: async ({ pageNumber = 1 }) => {
    const url = "CourseReview/Get-all-review-course-of-user";
    const config = {
      params: {
        pageNumber,
        pageSize: DEFAULT_PAGE_SIZE,
        orderBy: "createdAt desc",
        // keyword,
      },
    };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  getTotalReviewUser: async () => {
    const url = "CourseReview/Get-total-Review-of-User";
    const response = await axiosRequest.get(url);
    return response;
  },
  // Get review of course of an instructor
  getAllReviewsInstructor: async ({
    pageNumber = 1,
    keyword = "",
    rating = 0,
  }) => {
    const url = "CourseReview/Get-all-course-reviews-of-instructor";
    const config = {
      params: {
        pageNumber,
        pageSize: DEFAULT_PAGE_SIZE,
        orderBy: "createdAt desc",
        keyword,
        rating,
      },
    };
    if (rating === 0) {
      delete config.params.rating;
    }

    const response = await axiosRequest.get(url, config);
    return response;
  },
  getReviewSummaryInstructor: async () => {
    const url = "CourseReview/Get-Detail-Rating-Of-intructor";
    const response = await axiosRequest.get(url);
    return response;
  },
  getAverageRatingInstructor: async () => {
    const url = "CourseReview/Get-Avg-Rating-Of-Intructor";
    const response = await axiosRequest.get(url);
    return response;
  },
  getTotalReviewInstructor: async (params) => {
    const url = "CourseReview/Get-total-Review-of-Instructor";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
};

export { reviewApi };
